import { debounce } from "./functions";

const twoDigitRegex = /^[0-9]{2}$/;

// Sortcode handler
$(document).on(
    'keyup', 
    '.form-input-sortcode [id$=_1], .form-input-sortcode [id$=_2], .form-input-sortcode [id$=_3]', 
    debounce(
        (event) => {
            let target = $(event.target);
            let value = event.target.value;
            let formGroup = target.closest('.form-group');
            if (target.is('[id$=_1], [id$=_2]') && twoDigitRegex.test(value)) {
                // Move to the next field
                if (target.is('[id$=_1]')) {
                    $('[id$=_2]', formGroup).focus();
                }
                if (target.is('[id$=_2]')) {
                    $('[id$=_3]', formGroup).focus();
                }
            }
        }, 
        100, 
        false
    )
);
$(document).on(
    'change',
    '.form-input-sortcode [id$=_1], .form-input-sortcode [id$=_2], .form-input-sortcode [id$=_3]',
    (event) => {
        let target = $(event.target);
        let formGroup = target.closest('.form-group');
        let input = $('input[type=hidden]', formGroup);
        let oldValue = input.val(); 
        let one = $('[id$=_1]', formGroup).val();
        let two = $('[id$=_2]', formGroup).val();
        let three = $('[id$=_3]', formGroup).val();
        if (twoDigitRegex.test(one)
            && twoDigitRegex.test(two)
            && twoDigitRegex.test(three)) {
                let newValue = one + two + three;
                if (oldValue != newValue) {
                    input.val(newValue).change();
                }
        } else {
            if (oldValue != '') {
                input.val('').change();
            }
        }    
    }
);